module.exports = __webpack_public_path__ + "img/MK.d705bea2.svg";